export default __webpack_public_path__ + "58571f92b716ff19552ac24e63f109a2.png";